// extracted by mini-css-extract-plugin
export default {"header":"PaymentForm_header__yMfOI","legend":"PaymentForm_legend__Jfg0H","line":"PaymentForm_line__0L9K0","submit":"PaymentForm_submit__IzZGm"};